(function () {
  function initHvh(root) {
    if (!root || root.dataset.hvhBound === 'true') return;
    root.dataset.hvhBound = 'true';
    
      
      

      var video = root.querySelector('.hvh__video');
      var delayMs = Number(root.dataset.hvhDelayMs) || 500;
      var hideOnScrollPx = Number(root.dataset.hvhHideScrollPx) || 100;
      var inView = true;
      var currentMode = null;
      var retryTimer = null;
      var retryCount = 0;
      var maxRetries = 6;
      var reduceMotion = false;
      var ticking = false;
      var readyTriggered = false;
      var resizeTimer = null;

      try {
        reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      function isMobile() {
        try {
          return window.matchMedia('(max-width: 749px)').matches;
        } catch (e) {
          return window.innerWidth <= 749;
        }
      }

      function getMode() {
        return isMobile() ? 'mobile' : 'desktop';
      }

      function getSrc(mode) {
        if (!video) return '';
        return mode === 'mobile'
          ? (video.getAttribute('data-src-mobile') || video.getAttribute('data-src-desktop') || '')
          : (video.getAttribute('data-src-desktop') || video.getAttribute('data-src-mobile') || '');
      }

      function getPoster(mode) {
        if (!video) return '';
        return mode === 'mobile'
          ? (video.getAttribute('data-poster-mobile') || video.getAttribute('data-poster-desktop') || '')
          : (video.getAttribute('data-poster-desktop') || video.getAttribute('data-poster-mobile') || '');
      }

      function hardenVideo() {
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.removeAttribute('controls');
      }

      function clearRetry() {
        if (retryTimer) {
          clearTimeout(retryTimer);
          retryTimer = null;
        }
      }

      function tryPlay(delay) {
        if (!video || reduceMotion || document.hidden || !inView || video.classList.contains('is-error')) return;

        clearRetry();

        var run = function () {
          hardenVideo();
          try {
            var p = video.play();
            if (p && typeof p.then === 'function') {
              p.then(function () {
                retryCount = 0;
              }).catch(function () {
                if (retryCount >= maxRetries) return;
                retryCount += 1;
                retryTimer = setTimeout(function () { tryPlay(); }, retryCount < 3 ? 200 : 350);
              });
            }
          } catch (e) {
            if (retryCount >= maxRetries) return;
            retryCount += 1;
            retryTimer = setTimeout(function () { tryPlay(); }, retryCount < 3 ? 200 : 350);
          }
        };

        if (delay) setTimeout(run, delay);
        else run();
      }

      function applyVideoSource(force) {
        if (!video) return;

        var mode = getMode();
        var src = getSrc(mode);
        var poster = getPoster(mode);

        if (!src) {
          video.classList.add('is-error');
          return;
        }

        if (!force && currentMode === mode && video.getAttribute('src') === src) {
          tryPlay();
          return;
        }

        currentMode = mode;
        retryCount = 0;
        clearRetry();

        try { video.pause(); } catch (e) {}

        if (poster) video.setAttribute('poster', poster);
        video.setAttribute('preload', 'auto');

        if (video.getAttribute('src') != src) {
          video.setAttribute('src', src);
          try { video.load(); } catch (e) {}
        }

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            tryPlay();
          });
        });
      }

      function updateScrollState() {
        ticking = false;
        var scrollY = window.scrollY || window.pageYOffset || 0;
        if (scrollY > hideOnScrollPx) root.classList.add('is-scrolled');
        else root.classList.remove('is-scrolled');
      }

      function onScrollOrResize() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateScrollState);
        }
      }

      function revealHero() {
        if (readyTriggered) return;
        readyTriggered = true;
        root.classList.add('is-visible');
        window.setTimeout(function () {
          root.classList.add('is-animated');
          updateScrollState();
        }, 60);
      }

      function init() {
        updateScrollState();

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.target !== root) return;
              inView = entry.isIntersecting || entry.intersectionRatio > 0;
              if (!video) return;
              if (inView) tryPlay();
              else {
                try { video.pause(); } catch (e) {}
              }
            });
          }, { threshold: 0.01 });
          io.observe(root);
        }

        if (video) {
          hardenVideo();
          // Perf: don't start the multi-MB video download at DOMContentLoaded —
          // the poster is the LCP and must win the bandwidth race. Start the
          // video once the browser is idle (or after a short fallback delay).
          var startVideoOnce = function () {
            if (startVideoOnce._done) return;
            startVideoOnce._done = true;
            applyVideoSource(true);
          };
          if ('requestIdleCallback' in window) {
            requestIdleCallback(startVideoOnce, { timeout: 2500 });
          } else {
            setTimeout(startVideoOnce, 1200);
          }

          video.addEventListener('loadeddata', function () {
            video.classList.remove('is-error');
            retryCount = 0;
            tryPlay();
          });
          video.addEventListener('canplay', function () { tryPlay(); });
          video.addEventListener('waiting', function () { tryPlay(180); });
          video.addEventListener('stalled', function () { tryPlay(260); });
          video.addEventListener('error', function () {
            video.classList.add('is-error');
            clearRetry();
          });

          document.addEventListener('visibilitychange', function () {
            if (!document.hidden) tryPlay(60);
          });

          window.addEventListener('pageshow', function () { tryPlay(80); });
          window.addEventListener('focus', function () { tryPlay(60); });
          window.addEventListener('pointerdown', function () { tryPlay(); }, { passive: true, once: true });
          window.addEventListener('touchstart', function () { tryPlay(); }, { passive: true, once: true });

          try {
            var mql = window.matchMedia('(max-width: 749px)');
            if (mql && mql.addEventListener) {
              mql.addEventListener('change', function () { applyVideoSource(true); });
            } else if (mql && mql.addListener) {
              mql.addListener(function () { applyVideoSource(true); });
            }
          } catch (e) {}

          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              applyVideoSource(false);
              onScrollOrResize();
            }, 140);
          }, { passive: true });
        }

        window.setTimeout(revealHero, delayMs);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }

      window.addEventListener('scroll', onScrollOrResize, { passive: true });

      document.addEventListener('shopify:section:load', function (evt) {
        if (!evt || !evt.target || !evt.target.querySelector) return;
        if (!evt.target.querySelector('#' + root.id)) return;

        readyTriggered = false;
        root.classList.remove('is-visible', 'is-animated');
        updateScrollState();

        if (video) {
          video.classList.remove('is-error');
          applyVideoSource(true);
          tryPlay(80);
        }

        window.setTimeout(revealHero, 120);
      });
    
  }
  function initHvhSticky(sticky) {
    if (!sticky || sticky.dataset.hvhBound === 'true') return;
    sticky.dataset.hvhBound = 'true';
    
      
      

      var footerEl = document.querySelector('footer') || document.querySelector('#shopify-section-footer') || document.querySelector('[id*="footer"]');
      var showAfter = Number(sticky.dataset.hvhShowAfter) || 100;
      var hideBeforeFooter = Number(sticky.dataset.hvhHideBeforeFooter) || 120;
      var ticking = false;

      function isNearFooter() {
        if (!footerEl) return false;
        var footerRect = footerEl.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        return footerRect.top <= (viewportH - hideBeforeFooter);
      }

      function isDrawerOpen() {
        return document.body.classList.contains('overflow-hidden-mobile') ||
          document.body.classList.contains('overflow-hidden-tablet') ||
          document.body.classList.contains('overflow-hidden') ||
          document.documentElement.classList.contains('overflow-hidden');
      }

      function updateSticky() {
        ticking = false;
        var scrollY = window.scrollY || window.pageYOffset || 0;
        var show = scrollY > showAfter && !isNearFooter() && !isDrawerOpen();
        sticky.classList.toggle('is-visible', show);
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateSticky);
        }
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      document.addEventListener('visibilitychange', requestUpdate);
      requestUpdate();
    
  }
  function hvhBoot() {
    document.querySelectorAll('section[id^="hvh-"].hvh').forEach(initHvh);
    document.querySelectorAll('[id^="hvh-sticky-"]').forEach(initHvhSticky);
  }
  hvhBoot();
  document.addEventListener('shopify:section:load', hvhBoot);
})();
